import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { IUserGuideList } from '../model/guideList';

export const userGuideListKey = () => ['userGuide'];
export const userGuideListFn = () => apiClient.get(`${APP_API_URL}user-guide/get-list`);

export const userGuideListSelect = ({ data }: AxiosResponse<{ list: IUserGuideList }>) => data?.list || [];

export const useUserGuideListQuery = () => {
  return useQuery({
    queryKey: userGuideListKey(),
    queryFn: userGuideListFn,
    select: userGuideListSelect,
  });
};
